import { Col, Section, SectionHeading } from "@/components";
import { SectionLink } from "@anoki/fse-common";
import { TypographyKeys } from "@theme/typography.ts";
import clsx from "clsx";
import { ComponentType, PropsWithChildren, ReactNode } from "react";
import { RichText } from "../RichText";
import "./TableList.scss";

export enum TableAlignment {
  LEFT = "text-left",
  CENTER = "text-center",
  RIGHT = "text-right",
}

type TableListProps = PropsWithChildren<{
  title?: ReactNode;
  description?: ReactNode;
  links?: SectionLink[];
  asLink?: "a" | ComponentType<any>;
  fontSize?: TypographyKeys;
  mdFontSize?: TypographyKeys;
  classNameTitle?: string;
  additionalClass?: string;
  variantClassTable?: TableAlignment;
}>;

export const TableList = ({
  title,
  description,
  fontSize = "2",
  mdFontSize = "2",
  classNameTitle,
  additionalClass,
  variantClassTable = TableAlignment.LEFT,
  children,
}: TableListProps) => {
  const desc = !!description
    ? <RichText description={description}></RichText>
    : undefined;
  return (
    <Section
      className={clsx("base-col ui-table-list-section", additionalClass)}
    >
      <Col className="ui-table-list-content">
        <SectionHeading
          fs={fontSize}
          mdFs={mdFontSize}
          className={classNameTitle}
          titleMarginBottom="0"
          descriptionMarginBottom="0"
          color={"blue-48"}
          title={title}
          description={desc}
          descriptionClassName={clsx("text-slate-28", variantClassTable)}
        />
      </Col>
      {children}
    </Section>
  );
};
